import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { GlobalContext } from '@thd-olt-global/global-provider-component';
import { withRouter } from 'react-router-dom';
import * as types from '../../constants/ActionTypes';
import { EXTERNAL_NAMESPACE } from '../../constants/';

class AppWrapper extends Component {
  static singleton = false;
  static setDocumentReferrer = false;
  static contextType = GlobalContext;
  static mapStateToProps(state, ownProps) {
    const { location } = ownProps;
    return {
      reduxState: state,
      location,
    };
  }

  static mapDispatchToProps(dispatch, ownProps) {
    return {
      dispatch
    };
  }

  constructor(props) {
    super(props);
    this.experienceMetadata = {};
    if (typeof window !== 'undefined' && typeof window.experienceMetadata === 'string') {
      const exp = JSON.parse(window.experienceMetadata || '{}');
      this.experienceMetadata = exp;
    }
    if (typeof window !== 'undefined' && typeof window.experienceMetadata === 'object') {
      const exp = window.experienceMetadata;
      this.experienceMetadata = exp;
    }

  }

  componentDidMount() {
    if (!AppWrapper.singleton) {
      this.sessionFlush();
      this.bindEventBus();
      this.broadcastReady();
      this.broadcastRoute();
      this.initNewRelic();
      this.initGA();
      this.exposeUtilities();
      AppWrapper.singleton = true;
    }

  }
  componentDidUpdate(previousProps) {
    const previousLocation = previousProps.location;
    if (!previousLocation) return;
    const previousPath = previousLocation.pathname;
    const previousSearch = previousLocation.search;
    const previousUrl = previousPath + previousSearch;


    const { location: { pathname, search } } = this.props;
    const url = pathname + search;
    if (previousUrl !== url) {
      this.broadcastRoute();
      if (!AppWrapper.setDocumentReferrer) {
        this.setReferrerHeader(window.location.origin);
        AppWrapper.setDocumentReferrer = true;
      }
    }
  }

  setReferrerHeader = (referrerName) => {
    Object.defineProperty(document, 'referrer', {
      get: () => { return referrerName; },
    });
  };

  bindEventBus() {
    const { dispatch, history } = this.props;
    if (window.THD_EVENT_BUS) {
      window.THD_EVENT_BUS.on(`${types.FEATURE_STATE_LINKS}`, (props) => {
        if (props.output) {
          dispatch({ type: types.FEATURE_STATE_LINKS, ...props.output });
        }
      });
      window.THD_EVENT_BUS.on(`${types.FEATURE_STATE_LINK}`, (props) => {
        if (props.output) {
          dispatch({ type: types.FEATURE_STATE_LINK, ...props.output });
        }
      });
      window.THD_EVENT_BUS.on(`${types.FEATURE_STATE_RULE}`, (props) => {
        if (props.output) {
          dispatch({ type: types.FEATURE_STATE_RULE, ...props.output });
        }
      });
      window.THD_EVENT_BUS.on(`${types.FEATURE_STATE_RULES_RESET}`, (props) => {
        dispatch({ type: types.FEATURE_STATE_RULES_RESET });
      });

      window.THD_EVENT_BUS.on(`${EXTERNAL_NAMESPACE}/${types.NAVIGATE}`, (props = {}) => {
        const { location, type = 'push' } = props.output || {};
        if (type && history && history[type]) {
          history[type](location);
        }
      });
      window.THD_EVENT_BUS.lifeCycle.on('LOCALIZATION.localized', (props = {}) => {
        const { localStore = {} } = props.output || {};
        const normalizedLocalStore = {
          localStoreZip: localStore.address.postalCode,
          storeId: localStore.storeId,
          storeName: localStore.name
        };
        this.context.updateLocalStore(normalizedLocalStore);
      });

    }
  }

  broadcastRoute() {
    const { location, reduxState, dispatch } = this.props;
    if (window.THD_EVENT_BUS) {
      const props = {
        location,
        state: reduxState
      };

      window.THD_EVENT_BUS.trigger(`${EXTERNAL_NAMESPACE}/${types.LOCATION_CHANGE}`, props);
    }
    dispatch({ type: types.UPDATE_SESSION_TIMESTAMP });
  }

  broadcastReady = () => {
    if (window.THD_EVENT_BUS) {
      window.THD_EVENT_BUS.trigger(`${EXTERNAL_NAMESPACE}/${types.APP_LOAD}`);
    }
  };

  initNewRelic = () => {
    if (this.experienceMetadata) {
      const { version, name } = this.experienceMetadata;
      const { segment } = this.context.request || {};
      const { storeId } = this.context.localStore || {};
      if (window.newrelic && name && version) {
        window.newrelic.setCustomAttribute('canary', version);
        window.newrelic.addRelease(name, version);
        window.newrelic.setCustomAttribute('segment', segment);
        window.newrelic.setCustomAttribute('storeId', storeId);
        setTimeout(() => {
          if (typeof window.testversion !== 'undefined') {
            window.newrelic.setCustomAttribute('tnt', window.testversion);
          }
        }, 4000);
      }
      import(/* webpackChunkName: "perfMetrics" */ 'first-input-delay').then(() => {
        if (window.perfMetrics && window.newrelic) {
          window.perfMetrics.onFirstInputDelay(function (delay, evt) {
            const {
              type = '',
              target = {}
            } = evt;

            window.newrelic.addPageAction('InputDelay', {
              eventLabel: type,
              eventTarget: target.className,
              delay: Math.round(delay)
            });
          });
        }
      });
    }
    if (window.THD_EVENT_BUS && window.newrelic && window.location) {
      window.THD_EVENT_BUS.on(`${EXTERNAL_NAMESPACE}/PAGE_LOAD`, () => {
        const { href } = window.location;
        const { segment } = this.context.request || {};
        const { storeId } = this.context.localStore || {};
        window.newrelic.addPageAction('PAGE_LOAD', { href });
        window.newrelic.setCustomAttribute('segment', segment);
        window.newrelic.setCustomAttribute('storeId', storeId);
      });
    }
  };

  initGA = () => {
    const { version, name } = this.experienceMetadata;
    let attempts = 0;
    let interval;
    const gaFn = () => {
      attempts += 1;
      if (typeof window !== 'undefined' && window.ga && name && version) {
        if (interval) {
          clearInterval(interval);
        }
        window.ga('set', 'dimension10', name);
        window.ga('set', 'dimension11', version);
      } else if (attempts > 10 && interval) {
        clearInterval(interval);
      }
    };
    gaFn();
    interval = setInterval(gaFn, 500);
  };

  sessionFlush = () => {
    const { reduxState, dispatch } = this.props;
    const { timestamp = new Date().getTime() } = reduxState.feature;
    const now = new Date().getTime();
    const THIRTY_MINUTES = 1000 * 60 * 30;
    if (now - timestamp > THIRTY_MINUTES) {
      dispatch({ type: types.SESSION_FLUSH });
    }
  };

  exposeUtilities = async () => {
    if (typeof window !== 'undefined') {
      const cartPromise = import('thd-cart-bindings/dist/thd-cart-bindings.amd');
      const overlayPromise = import('thd-overlay/dist/thd-overlay.amd');
      const carouselPromise = import('thd-carousel');
      const [{ default: cartBindngs }, { default: thdOverlay }, { default: thdCarousel }] =
        await Promise.all([cartPromise, overlayPromise, carouselPromise]);
      window.tntExposedObjects = {
        'thd-carousel': thdCarousel,
        'thd-cart-bindings': cartBindngs,
        'thd-overlay': thdOverlay
      };
    }
  };

  render() {
    const { children } = this.props;
    return children;
  }
}

AppWrapper.propTypes = {
  dispatch: PropTypes.func.isRequired,
  children: PropTypes.node,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string
  }).isRequired,
  reduxState: PropTypes.shape({
    feature: PropTypes.shape({
      timestamp: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ])
    })
  })
};

AppWrapper.defaultProps = {
  children: null,
  history: {},
  reduxState: {}
};

export default withRouter(connect(
  AppWrapper.mapStateToProps,
  AppWrapper.mapDispatchToProps
)(AppWrapper));
